import { render, staticRenderFns } from "./KT-OpportunityTeam.vue?vue&type=template&id=79cef992&scoped=true&lang=true&"
import script from "./KT-OpportunityTeam.vue?vue&type=script&lang=js&"
export * from "./KT-OpportunityTeam.vue?vue&type=script&lang=js&"
import style0 from "./KT-OpportunityTeam.vue?vue&type=style&index=0&id=79cef992&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cef992",
  null
  
)

export default component.exports